export function forumStateReducer(
  state = {
    posts: {},
    loading: true,
    error: false,
    subjects: [],
    detailPost: {
      loading: true,
      error: false,
      post: {},
      comments: {}
    }
  },
  action
) {
  switch (action.type) {
    case "GET_FORUM_POSTS_START":
      return {
        ...state,
        loading: true
      };
    case "GET_FORUM_POSTS_ERROR":
      return {
        ...state,
        loading: false,
        error: true
      };
    case "GET_FORUM_POSTS_SUCCESS":
      return {
        ...state,
        loading: false,
        error: false,
        posts: action.payload
      };
    case "GET_SUBJECTS_SUCCESS":
      return {
        ...state,
        loading: false,
        error: false,
        subjects: action.payload
      };
    case "CREATE_FORUM_POST_SUCCESS": {
      state.posts[action.payload.key] = action.payload;
      return {
        ...state,
        error: false,
        posts: { ...state.posts }
      };
    }
    case "CREATE_FORUM_POST_ERROR": {
      return {
        ...state,
        error: true
      };
    }
    case "UPDATE_FORUM_POST_SUCCESS": {
      state.posts[action.payload.key] = action.payload;
      return {
        ...state,
        error: false,
        posts: { ...state.posts }
      };
    }
    case "UPDATE_FORUM_POST_ERROR": {
      return {
        ...state,
        error: true
      };
    }
    case "DELETE_FORUM_POST_SUCCESS": {
      if (state.detailPost.post.key === action.payload) {
        state.detailPost.post = {};
        state.detailPost.comments = {};
      }
      delete state.posts[action.payload];
      return {
        ...state,
        posts: { ...state.posts },
        detailPost: {
          ...state.detailPost
        }
      };
    }
    case "GET_POST":
      return {
        ...state,
        detailPost: { ...state.detailPost, post: action.payload }
      };
    case "GET_COMMENTS":
      return {
        ...state,
        detailPost: {
          ...state.detailPost,
          comments: action.payload,
          loading: false
        }
      };
    case "UPDATE_COMMENT":
      state.detailPost.comments[action.payload.key] = action.payload;
      return {
        ...state,
        detailPost: {
          ...state.detailPost
        }
      };
    case "DELETE_COMMENT":
      delete state.detailPost.comments[action.payload];
      state.detailPost.post.commentCount -= 1;
      return {
        ...state,
        detailPost: {
          ...state.detailPost
        }
      };
    case "ADD_COMMENT_SUCCESS":
      state.detailPost.comments[action.payload.key] = action.payload;
      state.detailPost.post.commentCount += 1;
      return {
        ...state,
        detailPost: {
          ...state.detailPost
        }
      };
    default:
      return state;
  }
}
